// extracted by mini-css-extract-plugin
export default {"main":"ChoiceMain_main__phoaL","style-nesting-0":"ChoiceMain_style-nesting-0__o-l0D","style-nesting-limit":"ChoiceMain_style-nesting-limit__Fotcn"};